module.exports = __webpack_public_path__ + "static/img/title-charging-order.95609ae2.png";